export default "__VITE_ASSET__DDWohip___"